import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, DetachedRouteHandle, Route, RouteReuseStrategy} from '@angular/router';

// Dafault strategy taken from CARS code
export class DefaultRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}

@Injectable()
export class CustomRouteReuseStrategy extends DefaultRouteReuseStrategy {
  public shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    if (this._doNotReuseRoute(future.routeConfig, current.routeConfig)) {
      return false;
    }
    return super.shouldReuseRoute(future, current);
  }

  // This prevents the reuse of routes when navigating within a departure
  private _doNotReuseRoute(futureConfig: Route, currentConfig: Route): boolean {
    return futureConfig?.path?.includes(':id') && currentConfig?.path?.includes(':id');
  }
}
